<template>
  <div class="big offline-Statistics">
    <div class="page_title flex_between">
      <span>线下活动——{{ routeQuery.act_name }}</span>
      <el-button type="primary" style="width: 92px" @click="back" size="medium"
        >返回</el-button
      >
    </div>

    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="top-header">
          <div class="search-box">
            <!-- 用户手机号 -->
            <div class="item">
              <span>用户手机号</span>
              <div class="item-content">
                <el-input
                  v-model="searchForm.user_phone"
                  size="small"
                  clearable
                  @keyup.enter.native="seachEnterFun"
                  placeholder="请输入"
                ></el-input>
              </div>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getList"
                >查询</el-button
              >
            </div>
          </div>
          <!-- 导出 -->
          <div style="margin-bottom: 10px">
            <el-button
              type="primary"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2002') : false
              "
              @click="exportBtn"
              >导出</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateTimeFormat }}
                </div>

                <div v-else-if="item.prop == 'sex'">
                  {{ scope.row[item.prop] | sexText }}
                </div>

                <div v-else>
                  {{ scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="140"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toUserDetails(scope.row)"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('41') : false
                  "
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>

      <!-- 链接 -->
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import activity from "@/api/activity.js";
import Pagination from "@/components/Pagination/index";
import router from "../../../router";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      searchForm: {
        user_phone: "",
      },

      tableHeader: [
        {
          label: "用户昵称",
          prop: "nick_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "用户手机号",
          prop: "user_phone",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "姓名",
          prop: "name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "性别",
          prop: "sex",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "年龄",
          prop: "age",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "手机号",
          prop: "phone",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "参与人数",
          prop: "num",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "报名时间",
          prop: "create_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      tableData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    dateTimeFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    sexText(val) {
      switch (val) {
        case 1:
          return "男";
        case 2:
          return "女";
        case 0:
          return "未知";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign(
        { act_id: this.routeQuery.act_id },
        this.pagination,
        this.searchForm
      );
      this.tableLoading = true;
      activity.offlineActivityStatistics(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.tableData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    toUserDetails(row) {
      let { user_id } = row;
      this.$router.push({
        path: "/home/patient/userdetail",
        query: {
          user_id,
        },
      });
    },
    // 导出
    exportBtn() {
      let params = Object.assign(
        { act_id: this.routeQuery.act_id },
        this.pagination,
        this.searchForm
      );
      const loading = this.$loading();
      activity
        .offlineActivityStatisticsExport(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${
              data.url
            }`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.offline-Statistics {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
